(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PackageFeatureListDetailController', PackageFeatureListDetailController);

    PackageFeatureListDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PackageFeatureList'];

    function PackageFeatureListDetailController($scope, $rootScope, $stateParams, entity, PackageFeatureList) {
        var vm = this;

        vm.packageFeatureList = entity;

        var unsubscribe = $rootScope.$on('tikonApp:packageFeatureListUpdate', function (event, result) {
            vm.packageFeatureList = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
